import { Section } from '@shared/components/Section';
import { barreiras, implantacao } from '@curso/content/implantacao';

/**
 * A aba da camada de implantação.
 *
 * É o diferencial que a página reivindicava sem sustentar. Responde de frente
 * a objeção que três dos cinco criadores citaram no briefing, e é o bloco que
 * fala com quem coordena, não com quem executa.
 *
 * Desde 19/10 ela também absorve o que o roteiro chamava de "Aprendizagem e
 * implementação" dentro das ferramentas: barreiras e o formulário de
 * implantação não são ferramenta de equipe, são isto aqui.
 *
 * A fonte do caso aparece na página. Material público do IHI, e a instituição
 * do caso continua sem nome de propósito.
 */
export function NaSuaUnidade() {
  return (
    <>
      <Section id="objecao" rotulo="A objeção" titulo={`"${implantacao.objecao}."`}>
        <p className="prosa">{implantacao.enquadramento}</p>
        <p className="prosa mt-5">{implantacao.tecnicoAdaptativo}</p>
      </Section>

      <Section id="o-que-esperar" rotulo="O que esperar" titulo="As barreiras têm nome">
        <p className="prosa mb-7">{implantacao.perguntaDasBarreiras}</p>

        <ul className="flex flex-wrap gap-2">
          {barreiras.map((barreira) => (
            <li
              key={barreira}
              className="border border-linha-forte px-3 py-1.5 text-miudo text-tinta-suave"
            >
              {barreira}
            </li>
          ))}
        </ul>
      </Section>

      <Section id="adesao" rotulo="Evidência" titulo={implantacao.tituloDoCaso}>
        <p className="prosa">{implantacao.caso}</p>
        <p className="prosa mt-5 text-tinta">{implantacao.remateDoCaso}</p>
        <p className="mt-6 border-l-2 border-linha-forte pl-4 text-miudo leading-relaxed text-tinta-fraca">
          {implantacao.fonte}
        </p>
      </Section>

      <Section
        id="da-evidencia-para-a-pratica"
        rotulo="Da evidência para a sua realidade"
        titulo={implantacao.tituloDaVolta}
      >
        <p className="prosa">{implantacao.volta}</p>
        <p className="prosa mt-5 text-tinta">{implantacao.remateDaVolta}</p>
      </Section>
    </>
  );
}
